import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import { Section } from '..';

import style from './BlogArticles.module.less';

interface BlogArticlesProps {
  header?: string;
  articles: any; // FIXME: create article type
}

export const BlogArticles = ({ articles, header }: BlogArticlesProps) => (
  <Section alternate={true}>
    {header ? (
      <div className={classnames(style.header)}>
        <h1>{header}</h1>
      </div>
    ) : ''}
    <div className={classnames(style.wrapper, style.content)}>
      {articles.map(({ node: article }) => (
        <div key={article.id} className={style.article}>
          <Link to={article.fields?.slug} className={style.linkImage}>
            <div
              className={style.image}
              style={{ backgroundImage: `url(${article.frontmatter?.image?.publicURL})` }}
            />
          </Link>
          <div className={style.blogPostTitle}>
            <Link to={article.fields?.slug} className={style.linkText}>
              <h3>{article.frontmatter.title}</h3>
            </Link>
            <div className={style.info}>
              {article.frontmatter.date}
              <span className={style.separator}>•</span>
              {article.timeToRead} MIN READ
            </div>
          </div>
        </div>
      ))}
    </div>
  </Section>
);
